import contentfulGql from 'js/lib/contentfulGql';

import { entWebsiteBlockAssemblyFragment } from 'bundles/ent-website/queries/EntWebsiteBlockAssembly';
import { entWebsitePartnerFragment } from 'bundles/ent-website/queries/EntWebsitePartnerList';

export const entWebsiteSkillsetsFragment = contentfulGql`#graphql
  ${entWebsitePartnerFragment}
  fragment EntWebsiteSkillsets on EntWebsiteSkillsets {
    slug
    headline
    description
    tabNames
    skillsetsCollection(limit: 12){
      items {
        slug
        difficulty
        skillTitle
        tabName
        skillsAcquiredTitle
        skillsAquired
        skillsGainedChecklistTitle
        skillsGainedChecklist
        partnersTitle
        partnersCollection(limit: 6){
          items {
            ...EntWebsitePartner
          }
        }
      }
    }
  }
`;

export const entWebsiteBlockSkillsetsQuery = contentfulGql`#graphql
  ${entWebsiteBlockAssemblyFragment}
  ${entWebsiteSkillsetsFragment}
  query entWebsiteBlockSkillsets($id: String!, $preview: Boolean, $locale: String!) {
    entWebsiteBlockAssembly(id: $id, preview: $preview, locale: $locale) {
      ...EntWebsiteBlockAssembly
      reference {
        __typename
        ...EntWebsiteSkillsets
      }
    }
  }
`;
